import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import LinearProgress from "@mui/material/LinearProgress";
import Modal from "@mui/material/Modal";
import Paper, { PaperProps } from "@mui/material/Paper";
import Slide from "@mui/material/Slide";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import { TransitionProps } from "@mui/material/transitions";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { createRoot, Root } from "react-dom/client";
import Draggable from "react-draggable";
import ModalContainer from "../../MainPage/Module/ModalContainer";
import { Prefixes } from "../../MainPage/Tools/ProjectX";
import { isEmptyObject } from "../../MainPage/Tools/Tools";
import smetaAxios from "../../SmetaAxios";
import { getUrlForRequest } from "../../Url";
import { CheckModalBackGrounds, tokenProcessingTest } from "../TokenProcessing";

// eslint-disable-next-line @typescript-eslint/naming-convention
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// eslint-disable-next-line @typescript-eslint/naming-convention
function PaperComponent(props: PaperProps) {
  return (
    <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

// eslint-disable-next-line @typescript-eslint/naming-convention
function ChildModal(props: any) {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    setOpen(true);
  }, [props.Path]);

  const handleClose = () => {
    setOpen(false);
  };

  async function handleCloseButton() {
    props.Cancel();
    setOpen(false);
  }

  return (
    <React.Fragment>
      <Draggable>
        <Modal hideBackdrop open={open}>
          <Box sx={{ ...style, width: "20%" }}>
            <h2 id="child-modal-title">Подтверждение</h2>
            <p id="child-modal-description">Остановить процесс?</p>
            <Button
              size="small"
              variant="outlined"
              style={{ textTransform: "none", marginRight: "10px" }}
              onClick={handleCloseButton}
            >
              Да
            </Button>
            <Button size="small" variant="outlined" style={{ textTransform: "none" }} onClick={handleClose}>
              Нет
            </Button>
          </Box>
        </Modal>
      </Draggable>
    </React.Fragment>
  );
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function ModalProgress(props: any) {
  const [open, setOpen] = useState(true);
  const [activeStep, setActiveStep] = useState(0);
  const [count, setCount] = useState<number>(0);
  const [data, setData] = useState<any>({});
  const [title, setTitle] = useState();
  const [allSteps, setAllSteps] = useState<any>([]);
  const [prevToken, setPrevToken] = useState("");
  const [textLoad, setTextLoad] = useState("");
  const [currentLoad, setCurrentLoad] = useState("Load");
  const dialogref = useRef<any>(null);

  useEffect(() => {
    if (data.error) {
      const message = `Ошибка выполнения операции на сервере: ${data.error.content}`;
      const renderDefaultEl = document.getElementById("RenderDefault")!;
      const renderDefaultElRoot: Root = renderDefaultEl.root || createRoot(renderDefaultEl);
      renderDefaultEl.root = renderDefaultElRoot;
      renderDefaultElRoot.render(<ModalContainer dlgType={"Ошибка"} content={message} />);
    }
    tokenProcessing(data);
    if (dialogref.current) {
      dialogref.current.hideDialog = () => {
        setOpen(false);
        const footerProcess = document.getElementById("footerProgress")!;
        const footerProcessRoot: Root = footerProcess.root || createRoot(footerProcess);
        footerProcess.root = footerProcessRoot;
        footerProcess?.firstChild?.remove();
        footerProcessRoot.render(<></>);
      };
    }
  }, [data]);

  useEffect(() => {
    tokenProcessing(props.Json);
    openDialog();
    setActiveStep(0);
    setCurrentLoad("Load");
    setTextLoad("");
  }, [props.Json]);

  function setCharAt(str: string, index: number, chr: any) {
    if (index > str.length - 1) return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
  }

  async function emptyRequest(requestID: string, load?: boolean) {
    const data = { Result: "" };
    smetaAxios
      .post("ResumeRequest", data, {
        prefix: Prefixes.default,
        params: { RequestID: requestID, WSM: "1" },
        loadMask: load ? load : false,
      })
      .then((res: any) => {
        setData(res);
      });
  }

  const normalise = (value: any, max: any) => ((Number(value) - 0) * 100) / (Number(max) - 0);

  async function tokenProcessing(json: any) {
    // (json,props)
    if (json.Break !== undefined) {
      const returnSmth = [];
      const token = json.Token;
      const requestID = json.Params.RequestID;
      if (token === "ShowProgressDialog") {
        let sectionsArray, section: any;
        const sections = json.Params.Sections;
        const title = json.Params.Title;

        if (sections !== undefined) {
          sectionsArray = sections.split(",");
          for (const value of Object.values(sectionsArray)) {
            let fixedSection: any = value;
            section = value;

            for (const [key, value] of Object.entries(section)) {
              if (value === section[Number(key) + 1] && value === '"') {
                fixedSection = setCharAt(fixedSection, Number(key), "");
              }
            }
            if (fixedSection[0] === '"' && fixedSection[fixedSection.length - 1] === '"') {
              fixedSection = setCharAt(fixedSection, 0, "");
              fixedSection = setCharAt(fixedSection, fixedSection.length - 1, "");
            }
            returnSmth.push(fixedSection);
          }
        }
        setOpen(true);
        setAllSteps(returnSmth);
        setTitle(title);
        setPrevToken(token);
        emptyRequest(requestID);
      } else if (token === "SetProgressSection") {
        let index = Number(json.Params.Index);
        if (isNaN(index)) index = 0;
        setActiveStep(index);
        setPrevToken(token);
        emptyRequest(requestID);
      } else if (token === "StepProgress") {
        let index = json.Params.Index;
        if (isNaN(index)) index = 0;
        const max = json.Params.Count;
        setCount(normalise(index, max));
        setPrevToken(token);
        emptyRequest(requestID);
      } else if (token === "SetProgressLabel") {
        const text = json.Params.Text;
        if (prevToken === "StepProgress") {
          setCurrentLoad("Mix");
          setTextLoad(text);
        } else if (
          prevToken === "SetProgressSection" ||
          prevToken === "SetProgressLabel" ||
          prevToken === "ShowProgressDialog"
        ) {
          setTextLoad(text);
          setCurrentLoad("Text");
        }
        setPrevToken(token);
        emptyRequest(requestID);
      } else if (token === "HideProgressDialog") {
        setPrevToken(token);
        setOpen(false);
        const renderModalSubEl = document.getElementById("RenderModalSub")!;
        const renderModalSubElRoot: Root = renderModalSubEl.root || createRoot(renderModalSubEl);
        renderModalSubEl.root = renderModalSubElRoot;
        renderModalSubElRoot.render(<></>);
        emptyRequest(requestID, true);
      } else if (token === "ClearOutPut") {
        emptyRequest(requestID);
      } else if (token === "OutPutText") {
        emptyRequest(requestID);
      } else {
        if (props.from) {
          tokenProcessingTest(json, {
            func: props.setReturnValue,
            from: props.from,
          });
        } else {
          tokenProcessingTest(json, { func: setData, from: "ModalProgress" });
        }
      }
    } else {
      if (props.setReturnValue !== undefined && !isEmptyObject(json)) {
        setOpen(false);
        if (props.from !== "Forms") {
          const footerProcessEl = document.getElementById("footerProgress")!;
          const footerProcessRoot: Root = footerProcessEl.root || createRoot(footerProcessEl);
          footerProcessEl.root = footerProcessRoot;
          footerProcessRoot.render(<></>);
          props.setReturnValue(json);
        } else if (props.from === "Forms") props.setReturnValue(json);
      }
    }
  }

  function renderCancelModal() {
    const renderModalSubEl = document.getElementById("RenderModalSub")!;
    const renderModalSubElRoot: Root = renderModalSubEl.root || createRoot(renderModalSubEl);
    renderModalSubEl.root = renderModalSubElRoot;
    renderModalSubElRoot.render(<ChildModal Path={props.path} openIt={open} Cancel={cancelProgress} />);
  }

  function openDialog() {
    if (props.open) {
      setOpen(true);
    }
  }

  function cancelProgress() {
    const params = new Map();
    params.set("prefix", "programs");
    params.set("comand", "StopProcess");
    params.set("smart", "1");
    params.set("Path", props.path);
    const url = getUrlForRequest(params);
    axios.post(url).then((resp) => {
      setOpen(false);
      const footerProcess = document.getElementById("footerProgress")!;
      const footerProcessRoot: Root = footerProcess.root || createRoot(footerProcess);
      footerProcess.root = footerProcessRoot;
      footerProcess?.firstChild?.remove();
      footerProcessRoot.render(<></>);
      if (resp.data.Params) {
        emptyRequest(resp.data.Params.RequestID);
      }
    });
  }

  return (
    <div>
      <Dialog
        disableEnforceFocus
        maxWidth={"sm"}
        id={"ProgressDialog" + props.Json.Params.RequestID}
        fullWidth
        style={{ overflow: "hidden", height: "100%" }}
        open={open}
        ref={dialogref}
        TransitionComponent={Transition}
        keepMounted
        PaperComponent={PaperComponent}
        sx={{
          "&.MuiDialog-container": {
            zIndex: 1000 + CheckModalBackGrounds(),
          },
          zIndex: 1000 + CheckModalBackGrounds(),
        }}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent style={{ paddingLeft: "35px" }}>
          <Grid
            style={{ display: "block" }}
            container
            direction="row"
            justifyContent="space-evenly"
            alignItems="center"
            spacing={2}
          >
            <Grid item id="Steps">
              <Stepper activeStep={activeStep} orientation="vertical" connector={<></>}>
                {allSteps.map((step: any) => (
                  <Step key={step}>
                    <StepLabel>{step}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ height: "60px", paddingRight: "4px" }}>
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item style={{ width: "78%", paddingRight: "26px", paddingTop: "4px" }}>
              <Grid style={{}}>{currentLoad === "Text" || currentLoad === "Mix" ? textLoad : <></>}</Grid>
              <Grid
                item
                style={{
                  marginBottom: currentLoad === "Mix" ? "21px" : "01px",
                }}
              >
                {currentLoad === "Load" || currentLoad === "Mix" ? (
                  <LinearProgress
                    variant="determinate"
                    value={count}
                    sx={{ ".MuiLinearProgress-bar": { transition: "none" } }}
                  />
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
            <Grid item style={{ paddingLeft: "20px" }}>
              <Button size="small" variant="outlined" style={{ textTransform: "none" }} onClick={renderCancelModal}>
                Отмена
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}
